import { render, staticRenderFns } from "./SalaryPaymentField.vue?vue&type=template&id=90a5c96c&scoped=true"
import script from "./SalaryPaymentField.vue?vue&type=script&lang=js"
export * from "./SalaryPaymentField.vue?vue&type=script&lang=js"
import style0 from "./SalaryPaymentField.vue?vue&type=style&index=0&id=90a5c96c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a5c96c",
  null
  
)

export default component.exports